var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "core-js/modules/es6.regexp.to-string", "core-js/modules/es6.date.to-string", "core-js/modules/es6.object.to-string", "@babel/runtime-corejs2/core-js/reflect/construct", "@babel/runtime-corejs2/helpers/classCallCheck", "@babel/runtime-corejs2/helpers/createClass", "@babel/runtime-corejs2/helpers/assertThisInitialized", "@babel/runtime-corejs2/helpers/inherits", "@babel/runtime-corejs2/helpers/possibleConstructorReturn", "@babel/runtime-corejs2/helpers/getPrototypeOf", "react", "prop-types", "classnames", "react-cookie"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("core-js/modules/es6.regexp.to-string"), require("core-js/modules/es6.date.to-string"), require("core-js/modules/es6.object.to-string"), require("@babel/runtime-corejs2/core-js/reflect/construct"), require("@babel/runtime-corejs2/helpers/classCallCheck"), require("@babel/runtime-corejs2/helpers/createClass"), require("@babel/runtime-corejs2/helpers/assertThisInitialized"), require("@babel/runtime-corejs2/helpers/inherits"), require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"), require("@babel/runtime-corejs2/helpers/getPrototypeOf"), require("react"), require("prop-types"), require("classnames"), require("react-cookie"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.es6Regexp, global.es6Date, global.es6Object, global.construct, global.classCallCheck, global.createClass, global.assertThisInitialized, global.inherits, global.possibleConstructorReturn, global.getPrototypeOf, global.react, global.propTypes, global.classnames, global.reactCookie);
    global.CookieBanner = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _es6Regexp, _es6Date, _es6Object, _construct, _classCallCheck2, _createClass2, _assertThisInitialized2, _inherits2, _possibleConstructorReturn2, _getPrototypeOf2, _react, _propTypes, _classnames, _reactCookie) {
  "use strict";

  var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

  var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

  _Object$defineProperty(_exports, "__esModule", {
    value: true
  });

  _exports.default = void 0;
  _construct = _interopRequireDefault(_construct);
  _classCallCheck2 = _interopRequireDefault(_classCallCheck2);
  _createClass2 = _interopRequireDefault(_createClass2);
  _assertThisInitialized2 = _interopRequireDefault(_assertThisInitialized2);
  _inherits2 = _interopRequireDefault(_inherits2);
  _possibleConstructorReturn2 = _interopRequireDefault(_possibleConstructorReturn2);
  _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf2);
  _react = _interopRequireWildcard(_react);
  _propTypes = _interopRequireDefault(_propTypes);
  _classnames = _interopRequireDefault(_classnames);
  _reactCookie = _interopRequireDefault(_reactCookie);

  function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

  function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

  var CookieBanner = /*#__PURE__*/function (_Component) {
    (0, _inherits2.default)(CookieBanner, _Component);

    var _super = _createSuper(CookieBanner);

    function CookieBanner(props) {
      var _this;

      (0, _classCallCheck2.default)(this, CookieBanner);
      _this = _super.call(this, props);
      _this.closeBanner = _this.closeBanner.bind((0, _assertThisInitialized2.default)(_this));
      _this.openCookieMore = _this.openCookieMore.bind((0, _assertThisInitialized2.default)(_this));
      _this.state = {
        cookieApproved: false
      };
      return _this;
    }

    (0, _createClass2.default)(CookieBanner, [{
      key: "UNSAFE_componentWillMount",
      value: function UNSAFE_componentWillMount() {
        this.setState({
          cookieApproved: _reactCookie.default.load('arte-cookie-banner_close') === 'true'
        });
      }
    }, {
      key: "closeBanner",
      value: function closeBanner() {
        var cookieOptions = {
          path: '/',
          maxAge: 31536000 // 1 year

        }; // One cookie for all arte subdomains

        if (window.location.host.indexOf('arte.tv') >= 0) {
          cookieOptions.domain = 'arte.tv';
        }

        this.setState({
          cookieApproved: true
        });

        _reactCookie.default.save('arte-cookie-banner_close', 'true', cookieOptions);
      }
    }, {
      key: "openCookieMore",
      value: function openCookieMore(event) {
        event.preventDefault();
        global.open(this.labels.href);
      }
    }, {
      key: "render",
      value: function render() {
        var labels = this.props.labels;
        return /*#__PURE__*/_react.default.createElement("div", {
          className: (0, _classnames.default)('next-cookie-banner', {
            'next-cookie-banner--hide': this.state.cookieApproved
          })
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "next-cookie-banner__wrapper"
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: "next-cookie-banner__left"
        }, /*#__PURE__*/_react.default.createElement("span", {
          className: "next-cookie-banner__text"
        }, labels.textLabel), /*#__PURE__*/_react.default.createElement("a", {
          className: "next-cookie-banner__more",
          href: labels.href,
          onClick: this.openCookieMore,
          "aria-label": labels.moreLabel
        }, labels.moreText)), /*#__PURE__*/_react.default.createElement("div", {
          className: "next-cookie-banner__right"
        }, /*#__PURE__*/_react.default.createElement("button", {
          className: "next-cookie-banner__close",
          onClick: this.closeBanner,
          type: "button",
          "aria-label": labels.closeLabel
        }, "\xD7"))));
      }
    }]);
    return CookieBanner;
  }(_react.Component);

  CookieBanner.propTypes = {
    labels: _propTypes.default.shape({
      closeLabel: _propTypes.default.string,
      href: _propTypes.default.string,
      moreLabel: _propTypes.default.string,
      moreText: _propTypes.default.string,
      textLabel: _propTypes.default.string
    })
  };
  CookieBanner.defaultProps = {
    labels: {
      closeLabel: "Fermer la barre d'avertissement sur l'utilisation des cookies",
      href: 'http://www.arte.tv/sites/fr/services/arte-et-les-cookies/',
      moreLabel: 'En savoir plus sur notre politique de données personnelles - nouvelle fenêtre',
      moreText: 'En savoir plus ?',
      textLabel: "En poursuivant votre navigation sur ce site, vous acceptez l'utilisation de cookies conformément à notre politique de données personnelles."
    }
  };
  var _default = CookieBanner;
  _exports.default = _default;
});